import React, { Fragment } from 'react';
import { connect } from 'react-redux';

import { serviceLocator } from 'infrastructure/ServiceLocator';
import { getTranslate, getActiveLanguage } from 'react-localize-redux';

import classnames from 'classnames';

import LayoutHelper from 'infrastructure/LayoutHelper';

import Typography from '@material-ui/core/Typography';

import CloseIcon from '@material-ui/icons/Close';
import Slide from '@material-ui/core/Slide';
import Grid from '@material-ui/core/Grid';
import ListItemText from '@material-ui/core/ListItemText';
import { withStyles } from '@material-ui/core/styles';

import Chip from '@material-ui/core/Chip';

import { Creatable } from 'react-select';
import {
  NativeSelect,
  CardActions,
  RadioGroup,
  FormControlLabel,
  Radio,
  TextField,
  FormControl,
  InputLabel,
  FormHelperText,
  Checkbox,
  Dialog,
  AppBar,
  Toolbar,
  IconButton,
  Button,
  Fab,
} from '@material-ui/core';
import Help from '@material-ui/icons/Help';
import { withPublicStudio } from '../ScheduleManagment/withPublicStudio';
import StudioScheduleView from '../Studio/StudioScheduleView';

import UserHelper from 'infrastructure/UserHelper';

function Transition(props) {
  return <Slide direction="up" {...props} />;
}

class BookingDialog extends React.Component {
  constructor(props) {
    super(props);

    this.state = {};
  }

  componentWillMount() {}

  componentDidMount() {}

  render() {
    return (
      <Dialog
        fullScreen
        open={this.props.open}
        onClose={this.props.onClose}
        aria-labelledby={this.props.translate('studio.classSignIn')}
        TransitionComponent={Transition}
      >
        <AppBar className={this.props.classes.appBar}>
          <Toolbar>
            <IconButton
              color="inherit"
              onClick={this.props.onClose}
              aria-label="Close"
            >
              <CloseIcon />
            </IconButton>
            <Typography
              variant="h6"
              color="inherit"
              className={this.props.classes.flex}
            >
              {this.props.translate('studio.classSignIn')}
            </Typography>
          </Toolbar>
        </AppBar>
        <Typography
          component="div"
          className={this.props.classes.mainTypography}
        >
          <StudioScheduleView
            studio={this.props.studio}
            teachersMap={this.props.teachersMap}
            owner={this.props.owner}
            teachers={this.props.teachersMap}
            bookableOnly={true}
          />
          <Fab
            onClick={this.props.onAsk}
            color="primary"
            className={this.props.classes.fab}
            variant="extended"
          >
            <Help />
            {this.props.translate('studio.ask')}
          </Fab>
        </Typography>
      </Dialog>
    );
  }
}

function mapStateToProps(state, ownProps) {
  let translate = getTranslate(state.locale);
  let currentLanguage = getActiveLanguage(state.locale).code;
  let user = state.user;
  let myStudios = state.myStudios;
  return { translate, currentLanguage, user, myStudios };
}

export default withStyles((theme) => ({
  appBar: {
    position: 'relative',
  },
  grid: {
    width: '60%',
  },
  textField: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    width: 200,
  },
  mainTypography: { margin: theme.spacing(1) },
  bigAvatar: {
    margin: 10,
    width: 100,
    height: 100,
  },
  paperActivity: {
    ...theme.mixins.gutters(),
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
  },
  root: {
    flexGrow: 1,
  },
  tabs: {
    flexGrow: 1,
  },
  onHoldTab: {
    padding: 8 * 3,
  },
  fab: {
    position: 'fixed',
    right: theme.spacing(1),
    bottom: theme.spacing(1),
    zIndex: 10000,
  },
  subTeacherInfo: {
    paddingTop: '0px',
    paddingBottom: '0px',
  },
  teacherInfo: {
    paddingTop: '0px',
    paddingBottom: '0px',
  },
  unavailableNotification: {
    border: '1px solid #d0d0d2',
    background: 'rgba(212,88,63, 0.1)',
  },
  actions: {
    display: 'flex',
  },
  expand: {
    transform: 'rotate(0deg)',
    marginLeft: 'auto',
    transition: theme.transitions.create('transform', {
      duration: theme.transitions.duration.shortest,
    }),
  },
  expandOpen: {
    transform: 'rotate(180deg)',
  },
  paper: {
    ...theme.mixins.gutters(),
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
  },
  field: {
    display: 'flex',
    flexDirection: 'column',
    margin: `${theme.spacing(2)}px 0`,
  },
  label: {
    marginBottom: theme.spacing(1),
    position: 'relative',
    transform: 'none',
    display: 'flex',
    alignItems: 'center',
  },
}))(connect(mapStateToProps)(BookingDialog));
